import { FC, Fragment } from "react";
import { InputCardPrincipal } from "../atoms/InputCardPrincipal";
import { InputGroupCard } from "../molecules/InputGroupCard";

export type InputsCardCardprops = {
  tittle: string;
  idInputTop: string;
  nameInputTop: string;
  placeholderInputTop: string;
  idInputLeft: string;
  nameInputLeft: string;
  placeholderInputLeft: string;
  idInputRight: string;
  nameInputRight: string;
  placeholderInputRight: string;
  labelInputTop?: string;
  labelInputLeft?: string;
  labelInputRight?: string;
};

export const InputsCard: FC<InputsCardCardprops> = ({
  tittle,
  idInputTop,
  nameInputTop,
  placeholderInputTop,
  idInputLeft,
  nameInputLeft,
  placeholderInputLeft,
  idInputRight,
  nameInputRight,
  placeholderInputRight,
}) => {
  return (
    <Fragment>
      <fieldset>
        <legend className="block text-sm font-medium leading-6 text-gray-900">
          {tittle}
        </legend>
        <div className=" -space-y-px rounded-md bg-white shadow-sm">
          <div>
            <InputCardPrincipal
              id={idInputTop}
              name={nameInputTop}
              placeholder={placeholderInputTop}
            />
          </div>
          <InputGroupCard
            idOne={idInputLeft}
            nameOne={nameInputLeft}
            placeholderOne={placeholderInputLeft}
            idTwo={idInputRight}
            nameTwo={nameInputRight}
            placeholderTwo={placeholderInputRight}
          />
        </div>
      </fieldset>
    </Fragment>
  );
};
